import { toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fpgFilterItem flat-form"
}
const _hoisted_2 = { class: "fpgFilterItem-list__content-fastSearch" }
const _hoisted_3 = { class: "fpgFilterItem-list__content-items" }
const _hoisted_4 = {
  key: 0,
  class: "fpgFilterItem-list__content-items-empty"
}
const _hoisted_5 = ["for"]
const _hoisted_6 = ["onChange", "checked", "id"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "dt__filter-content-selectBlock-elem" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("rect", {
  y: "1.11133",
  width: "1",
  height: "12",
  rx: "0.5",
  transform: "rotate(-45 0 1.11133)",
  fill: "#EAEDF0"
}, null, -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("rect", {
  x: "8.48535",
  y: "0.40332",
  width: "1",
  height: "12",
  rx: "0.5",
  transform: "rotate(45 8.48535 0.40332)",
  fill: "#EAEDF0"
}, null, -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.mode === 'filter')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["fpgFilterItem-list", {'fpgFilterItem-list_hidden' : !$data.showAll}])
        }, [
          _createElementVNode("div", {
            class: "fpgFilterItem-list__header",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.showAll = !$data.showAll))
          }, [
            _createTextVNode(_toDisplayString(this.filter.label) + " ", 1 /* TEXT */),
            _createCommentVNode("                <span v-if=\"this.filter.value.selected.length > 0\">{{this.filter.value.selected.length}}</span>")
          ]),
          (this.filter.value.selected.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (this.remove && this.remove(...args))),
                class: "fpgFilterItem-list__clearBtn"
              }))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", {
            class: _normalizeClass(["fpgFilterItem-list__content", {
                'fpgFilterItem-list__content_more' : !this.showAdditionOption,
            }])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Поиск",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.query) = $event)),
                onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.onFilterOptions && $options.onFilterOptions(...args))),
                class: "form-control form-control-xs"
              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [
                  _vModelText,
                  $data.query,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_3, [
              ($data.query && this.options.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Нет совпадений. Измените фильтр поиска "))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.options, (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: option.id,
                  class: "custom-checkbox custom-checkbox_xs"
                }, [
                  _createElementVNode("label", {
                    for: option.id
                  }, [
                    _createElementVNode("input", {
                      onChange: (event) => $options.onChange(option),
                      checked: $options.onChecked(option),
                      type: "checkbox",
                      id: option.id,
                      class: "form-check-input"
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_6),
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(option.value), 1 /* TEXT */)
                  ], 8 /* PROPS */, _hoisted_5)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            (!$data.query)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (this.options.length > 5)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => ($data.showAdditionOption = !$data.showAdditionOption)),
                        class: "fpgFilterItem-list__content-more"
                      }, _toDisplayString($data.showAdditionOption ? 'Скрыть' : 'Показать всё (+' + (this.filter.options.length - 5) + ')'), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ], 2 /* CLASS */)
      ]))
    : ($props.filter.hasValue())
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(this.filter.value.selected, (option) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("span", null, _toDisplayString(option.value), 1 /* TEXT */),
            (_openBlock(), _createElementBlock("svg", {
              onClick: ($event: any) => ($options.onSelectOption(option)),
              width: "10",
              height: "10",
              viewBox: "0 0 10 10",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, _hoisted_12, 8 /* PROPS */, _hoisted_9))
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true)
}